export const confirmedAndSelected = ({ status, response }: IBaseRequestItem) => {
  return status == 'selected' && response === 'confirmed'
}
export const selectedParentItem = ({ status, response, parent_id }: IProductRequestItem) => {
  return status == 'selected' && response === 'confirmed' && !parent_id
}

export const filterByPendingServiceRequests = (productRequestItem: IProductRequestItem) => {
  return (
    productRequestItem.change_status === 'service_requested' &&
    productRequestItem.response === 'pending' &&
    !productRequestItem.parent_id
  )
}

export function filterByReferencedRequestItems(requestItem: IProductRequestItem) {
  if (!requestItem) {
    return () => false
  }

  return (item: IProductRequestItem) => {
    return requestItem.item.referred_items_reference_numbers.includes(
      Number(item.item.reference_number)
    )
  }
}
